import { clamp, map, breakpoint } from "../utils/utils.js";

class TypeCaptions {
  constructor() {
    const el = document.querySelector(".c-type-actions-inner");
    if (!el) return;

    this.scroll = window.scrollY;
    this.typecaptions = [0, 100];
    this.typecaptionsMax = 100;
    this.typecaptionsOut = el;
    this.typecaptionsInner = document.querySelector(".c-type-captions-inner");
    this.typecaptionsItems = document.querySelectorAll(
      "div[data-divscrollcenter]"
    );

    this.typeCaptionsResize();
    this.typeCaptionsScroll();
    window.addEventListener("resize", this.typeCaptionsResize.bind(this));
    window.addEventListener("scroll", this.typeCaptionsScroll.bind(this));
  }

  typeCaptionsScroll() {
    const breakpointItem = breakpoint();
    if (breakpointItem === "mobile" || breakpointItem === "tablet") return;
    this.scroll = window.scrollY;

    const mapTypeCaptionsPerc = clamp(
      map(this.typecaptions, [0, 100], this.scroll),
      0,
      100
    );
    const mapTypeCaptionsMax = map(
      [0, 100],
      [0, this.typecaptionsMax],
      mapTypeCaptionsPerc
    );

    this.typecaptionsInner.style.transform = `translateX(-${mapTypeCaptionsMax}px)`;
  }

  typeCaptionsResize() {
    this.scroll = window.scrollY;

    const breakpointItem = breakpoint();

    // vars
    this.typecaptionsInnerOut = document.querySelector(
      ".c-type-captions-inner-out"
    );
    this.typecaptionsMain = document.querySelector(".c-type-captions-wrap");
    // addd sides to Captions
    this.typecaptions_items =
      this.typecaptionsMain.querySelectorAll(".c-type-captions");

    //

    if (breakpointItem === "mobile" || breakpointItem === "tablet") {
      this.typecaptionsMain.removeAttribute("style");
      this.typecaptionsInner.removeAttribute("style");
      this.typecaptionsInnerOut.removeAttribute("style");

      for (let i = 0; i < this.typecaptionsItems.length; i++) {
        const tcEl = this.typecaptionsItems[i];
        const type = tcEl.dataset.divscrollcenter;

        tcEl.removeAttribute("style");
        tcEl.removeAttribute("style");
        if (type === "main") {
          this.typecaptionsOut.removeAttribute("style");
        }
      }

      this.typecaptions_items =
        this.typecaptionsMain.querySelectorAll(".c-type-captions");
      for (let i = 0; i < this.typecaptions_items.length; i++) {
        const typeEl = this.typecaptions_items[i];
        typeEl.removeAttribute("style");
      }

      return;
    }

    this.typecaptionsInnerOut.style.display = `flex`;
    this.typecaptionsInner.style.flex = `none`;
    this.typecaptionsWidth = this.typecaptionsMain.offsetWidth;
    this.typecaptionsInnerHeight = this.typecaptionsInner.offsetHeight;
    this.typecaptionsMain.style.height = `${this.typecaptionsInnerHeight}px`;

    for (let i = 0; i < this.typecaptions_items.length; i++) {
      const typeEl = this.typecaptions_items[i];
      if (i === 0) {
        typeEl.style.marginLeft = `${
          (this.typecaptionsWidth - typeEl.offsetWidth) / 2
        }px`;
      }
      if (i === this.typecaptions_items.length - 1) {
        typeEl.style.marginRight = `${
          (this.typecaptionsWidth - typeEl.offsetWidth) / 2
        }px`;
      }
    }

    // scroll calc
    for (let i = 0; i < this.typecaptionsItems.length; i++) {
      const tcEl = this.typecaptionsItems[i];
      const type = tcEl.dataset.divscrollcenter;

      if (type === "before") {
        tcEl.style.position = "sticky";
        const tcElHeight = tcEl.offsetHeight;
        tcEl.style.top = `-${
          tcElHeight - (window.innerHeight - this.typecaptionsInnerHeight)
        }px`;
        tcEl.style.marginBottom = `${this.typecaptionsInnerHeight}px`;
      }
      if (type === "main") {
        tcEl.style.marginTop = `-${this.typecaptionsInnerHeight}px`;
        const { top = 0, bottom = 0 } = tcEl.getBoundingClientRect();
        const topItem = window.innerHeight - this.typecaptionsInnerHeight;
        this.typecaptionsOut.style.top = topItem + "px";
        const takeHeightWindow =
          window.innerHeight - this.typecaptionsInnerHeight;
        this.typecaptions = [
          top + this.scroll - takeHeightWindow,
          bottom + this.scroll - window.innerHeight,
        ];
      }
    }

    const typecaptionsInnerWidth = this.typecaptionsInner.offsetWidth;
    this.typecaptionsMax = typecaptionsInnerWidth - this.typecaptionsWidth;
  }
}

export default TypeCaptions;
